import React, { useState, useEffect, useContext } from "react";
import "./FormData.css"
import { validate } from "rut.js";
import { loadAnimation } from "lottie-web";
import { defineElement } from 'lord-icon-element';
import { useNavigate } from 'react-router-dom';
import logo_payku from '../../img/logo_payku.png';
import TextField from "@mui/material/TextField";
import MenuItem from '@mui/material/MenuItem';
import { Alert, Button, Dialog, DialogActions, DialogContent, FormControl, InputLabel, OutlinedInput, Select, Snackbar } from "@mui/material";
import Footer from "../Footer/Footer";
import axios from "axios";
import { Box } from "@mui/system";
import InfoContext from "../../Context";


const ITEM_HEIGHT = 150;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const typeCount = [

    {
        value: 1,
        label: 'Corriente',
    },
    {
        value: 2,
        label: 'Visa / cuenta RUT',
    },
    {
        value: 3,
        label: 'Ahorro',
    },
];

function FormData() {
    const [bank, setBank] = useState('');
    const [rutError, setRutError] = useState('')
    const [titular, setTitular] = useState('')
    const [errorTitular, setErrorTitular] = useState('')
    const [numCuenta, setNumCuenta] = useState('')
    const [numRut, setNumRut] = useState('')
    const [errorNumCuenta, setErrorNumCuenta] = useState('')
    const [numTelefono, setNumtelefono] = useState('')
    const [errorNumtelefono, setErrorNumTelefono] = useState('')
    const [openModalSuccess, setopenModalSuccess] = useState(false);
    const [openModalFailed, setopenModalfailed] = useState(false);
    const [openAlertFailed, setOpenAlertFailed] = useState(false);
    const [openModalEmpty, setOpenModalEmpty] = useState(false);
    const userStyle = JSON.parse(sessionStorage.getItem("dataStyle"));
    const selectBank = JSON.parse(sessionStorage.getItem("dataBank"));
    const { setUserSession, userSession } = useContext(InfoContext);

    let userInfo = { 'user': 0 };


    const navigate = useNavigate();
    const navigateActive = () => {
        navigate('/');
    }

    const handleBank = (event) => {
        setBank(event.target.value);

    };
    const [type, setType] = useState('');
    const handleType = (event) => {
        setType(event.target.value);
    };
    const valideTitular = (event) => {
        setTitular(event.target.value)
        if (event.target.value.length === 0) {
            setErrorTitular('debe ingresar un Nombre')
        } else {
            setErrorTitular('')
        }
    }
    const valideNumCuenta = (event) => {
        setNumCuenta(event.target.value)
        if (event.target.value.length === 0) {
            setErrorNumCuenta('debe ingresar un número de cuenta')
        } else {
            setErrorNumCuenta('')
        }
    }
    const handleRut = (event) => {
        setNumRut(event.target.value)
        const valide = validate(event.target.value);
        if (valide === false) {
            setRutError('debe ingresar un rut válido')
        } else {
            setRutError('')
        }
    }
    const valideNumTelefono = (event) => {
        setNumtelefono(event.target.value)
        if (event.target.value.length === 0) {
            setErrorNumTelefono('debe ingresar un número de teléfono')
        } else {
            setErrorNumTelefono('')
        }
    }
    const handleClose = () => {
        setopenModalSuccess(false);
        handleClick()
    };
    const handleCloseFailed = () => {
        setopenModalfailed(false);
        handleClick()
    };
    const handleCloseEmpty = () => {
        setOpenModalEmpty(false);
    };


    const handle_submit = async () => {
        const res = await axios.post(process.env.REACT_APP_URL, {
            "access_key": process.env.REACT_APP_TOKEN,
            "action": "register",
            "accountbank_name": titular,
            "accountbank_num": numCuenta,
            "accountbank_type": Number(type),
            "phone": numTelefono,
            "accountbank_rut": numRut,
            "accountbank_sbif": bank,
            "id": selectBank.dataBank.id

        });
        if (res.data.status === "success") {
            setopenModalSuccess(true)
        } if (res.data.status === "failed") {
            setopenModalfailed(true)
            setTitular('')
            setNumCuenta('')
            setNumRut('')
            setNumtelefono('')
            setType('')
            setBank('')
        } if (res.data.status === "INVALID") {
            setOpenModalEmpty(true)
        }

    }
    const handleClick = () => {
        sessionStorage.clear();
        window.open('https://payku.cl/', '_self')
        userInfo.user = 0
        sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
        setUserSession(userInfo)

    }

    const buttonStyle = {
        color: `${userStyle?.data?.buttonLetters}`,
        background: `${userStyle?.data?.buttonColor}`,
    }
    const preURL = process.env.REACT_APP_URL_IMG

    const backgroundStyle = {
        backgroundImg: `url('${preURL}${userStyle?.data.backgroundImg}`,
        backgroundColor: `${userStyle?.data.backgroundColor}`,
    }
    useEffect(() => {
        if (userSession?.userLog?.user === 0) {
            navigateActive()
        }
        if (userStyle?.data.backgroundType === 'fixed') {
            document.body.style.background = backgroundStyle.backgroundImg
            document.body.style.backgroundSize = "cover";
        }
        if (userStyle?.data.backgroundType === 'color') {
            document.body.style.background = backgroundStyle.backgroundColor
        }
        if (userStyle?.data.backgroundType === 'repeat') {
            document.body.style.background = backgroundStyle.backgroundImg

        }
        var x = window.matchMedia("(max-width: 420px)")
        if (!x.matches) {
            document.body.style.backgroundRepeat = 'no-repeat';
            document.body.style.backgroundPosition = "top";
            document.body.style.backgroundSize = "cover";
            document.body.style.width = "100%";
            document.body.style.height = "100vh";
            document.body.style.position = "fixed";
            document.body.style.backgroundAttachment = 'fixed';

        }
    }, [userStyle])


    const empty = titular.length === 0 || numCuenta.length === 0 || numCuenta.length === 0 || numTelefono.length === 0
    const disabled = rutError.length !== 0 || errorNumCuenta.length !== 0 || errorNumtelefono.length !== 0



    defineElement(loadAnimation);
    return (
        <div className="Container">
            <div className="cardContainer">
                <div className="nav">
                    <img className="img-logo" src={logo_payku} alt="logo" />
                </div>
                <hr />
                <div className="title-formData">
                    <p>Datos de la cuenta en la que recibirá su dinero</p>
                </div>
                <form className="form-card" >
                    <div className="form">
                        <div className="formData">
                            <div className="input">
                                <Box
                                    sx={{
                                        maxWidth: '100%',

                                    }}
                                >
                                    <TextField
                                        fullWidth
                                        id="input"
                                        label="Titular"
                                        variant="standard"
                                        required="required"
                                        value={titular}
                                        onChange={(event) => valideTitular(event)}
                                        InputLabelProps={{ style: { fontSize: 16 } }}
                                    />
                                </Box>
                                <p className="errorStyle-formData">{errorTitular}</p>
                            </div>
                            <div className="input">
                                <Box
                                    sx={{
                                        maxWidth: '100%',
                                    }}

                                >
                                    <TextField
                                        fullWidth
                                        id="input"
                                        label="Número de teléfono"
                                        variant="standard"
                                        required="required"
                                        type="number"
                                        value={numTelefono}
                                        onChange={(event) => valideNumTelefono(event)}
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value))
                                                .toString()
                                                .slice(0, 9);
                                        }}
                                        InputLabelProps={{ style: { fontSize: 16 } }}
                                    />
                                </Box>
                                <p className="errorStyle-formData">{errorNumtelefono}</p>
                            </div>
                        </div>
                        <div className="formData1">
                            <div className="input">
                                <Box
                                    sx={{
                                        maxWidth: '100%',
                                    }}
                                >
                                    <TextField
                                        fullWidth
                                        id="input"
                                        label="Número de cuenta"
                                        variant="standard"
                                        required="required"
                                        type="number"
                                        value={numCuenta}
                                        onChange={(event) => valideNumCuenta(event)}
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value))
                                                .toString()
                                                .slice(0, 13);
                                        }}
                                        InputLabelProps={{ style: { fontSize: 16 } }}

                                    />
                                </Box>
                                <p className="errorStyle-formData">{errorNumCuenta}</p>
                            </div>
                            <div className="input">
                                <Box
                                    sx={{
                                        maxWidth: '100%',
                                    }}
                                >
                                    <FormControl fullWidth >
                                        <TextField
                                            fullWidth
                                            required
                                            id="input"
                                            select
                                            label="Tipo de Cuenta"
                                            variant="standard"
                                            value={type}
                                            onChange={(event) => handleType(event)}
                                            InputLabelProps={{ style: { fontSize: 16 } }}

                                        >
                                            {typeCount.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </FormControl>
                                </Box>
                            </div>
                        </div>
                        <div className="formData2">
                            <div className="input">
                                <Box
                                    sx={{
                                        maxWidth: '100%',
                                    }}
                                >
                                    <TextField
                                        fullWidth
                                        id="input"
                                        label="RUT"
                                        variant="standard"
                                        required="required"
                                        value={numRut}
                                        onChange={(event) => handleRut(event)}
                                        inputProps={{
                                            maxLength: 9,
                                          }}
                                        InputLabelProps={{ style: { fontSize: 16 } }}
                                    />
                                </Box>
                                <p className="errorStyle-formData">{rutError}</p>
                            </div>
                            <div className="input">
                                <Box
                                    sx={{
                                        maxWidth: '100%',
                                    }}
                                >
                                    <FormControl fullWidth required>
                                        <InputLabel id="labelBanco"> Seleccione Banco</InputLabel>
                                        <Select
                                            id="menu"
                                            label="Banco"
                                            variant="standard"
                                            value={bank}
                                            onChange={(event) => handleBank(event)}
                                            MenuProps={MenuProps}
                                        >
                                            {selectBank?.dataBank.bank.map((item) => (
                                                <MenuItem key={item.name} value={item.code}>
                                                    {item.name}
                                                </MenuItem>
                                            ))}


                                        </Select>
                                    </FormControl>
                                </Box>
                                <p className="errorStyle-formData"></p>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="section-button-form">
                        <div className="button">
                            <Button
                                id="button-form"
                                type="submit"
                                onClick={handleClick}
                                style={buttonStyle}
                            >

                                Salir
                            </Button>
                        </div>
                        <div className="button">
                            <Button
                                onClick={handle_submit}

                                id="button-form"
                                disabled={disabled || empty}
                                style={buttonStyle}
                            >
                                Enviar
                            </Button>
                        </div>
                    </div>
                </form>
                <Footer />
            </div>
            <Dialog
                className="modalSucess"
                open={openModalSuccess}
            >
                <DialogContent>
                    <div className="Success">
                        <h4>¡Sus datos bancarios han sido enviados exitosamente!</h4>
                    </div>
                    <DialogActions>
                        <Button onClick={handleClose}>Aceptar</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
            <Dialog
                className="modalSucess"
                open={openModalFailed}
            >
                <DialogContent>
                    <div className="Success">
                        <h4>Anulación no encontrada</h4>
                    </div>
                    <DialogActions>
                        <Button onClick={handleCloseFailed}>Aceptar</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
            <Dialog
                className="modalEmpty"
                open={openModalEmpty}
            >
                <DialogContent>
                    <div className="Success">
                        <h4>Todos los campos son obligatorios.</h4>
                    </div>
                    <DialogActions>
                        <Button onClick={handleCloseEmpty}>Aceptar</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
            <Snackbar
                open={openAlertFailed}
                autoHideDuration={4000}
                onClose={() => setOpenAlertFailed(false)}
            >
                <Alert severity="error" sx={{ width: "100%" }}>
                    Hubo un error inesperado, por favor intente nuevamente.
                </Alert>
            </Snackbar>
        </div>
    )
}

export default FormData